import { actorRowFor } from './movement-truth';
import { buildAppliedFrame } from '../janus-engine/transport/applied-frame';
import { saveAppliedTruth } from '../shared/applied-truth-transport';
import { itemField, upper, type Row } from '../janus-engine/ability/context';

/** The existing applied transport installs one saved row on every held reactor copy. */
export async function setReactionConsent(encounterId: string, actorId: string, abilityId: string, mode: string): Promise<void> {
  encounterId = upper(encounterId); actorId = upper(actorId); abilityId = upper(abilityId);
  const reactor = (actorRowFor(encounterId, actorId) ?? window.FateTide?.casterCache?.get(actorId)) as Row | null;
  if (!reactor || !ftHasPlayerPermission(reactor) || !window.ftPushAppliedTruth || !['ask', 'auto'].includes(mode)) return;
  if (upper(ftEncounterCreatureField(reactor.encounter_creatures, 'encounter_id')) !== encounterId) return;
  const held = Array.isArray(reactor.reaction_consents) ? reactor.reaction_consents as Row[] : [];
  const previous = held.find(row => upper(itemField(row, 'reaction_consent_ability_id')) === abilityId);
  const id = upper(previous && itemField(previous, 'reaction_consent_id')) || crypto.randomUUID().toUpperCase();
  const expected = Number(ftEncounterCreatureField(reactor.encounter_creatures, 'movement_rev') ?? 0);
  const command = { schema: 'janus.reaction-consent.v1', kind: 'reaction_consent', operation_id: crypto.randomUUID().toUpperCase(),
    encounter_id: encounterId, actor_id: actorId, expected_rev: expected, ability_id: abilityId, reaction_consent_id: id, mode };
  const rev = expected + 1;
  const row = { reaction_consent_id: id, reaction_consent_creature_id: actorId, reaction_consent_ability_id: abilityId,
    reaction_consent_mode: mode, reaction_consent_deleted: 0 };
  const frame = buildAppliedFrame({ operation_id: command.operation_id, encounter_id: encounterId, actor_id: actorId, rev,
    member_revs: { [actorId]: rev }, rows: [
      { table: 'encounter_creatures', row_id: actorId, partial: true, row: { movement_rev: rev } },
      { table: 'reaction_consents', row_id: id, row },
    ], computed: {}, computed_delta: { [actorId]: { set: [], unset: [] } }, new_entities: [], deletes: [] }, Infinity);
  try {
    await window.ftPushAppliedTruth({ type: 'janus_status_truth', command: { ...command, rev }, applied_frame: frame });
    const response = await saveAppliedTruth('/options/game/actions/reaction_consent_save_inc.php', command,
      { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(command) });
    const result = await response.json() as { ok?: boolean; error?: string };
    if (!response.ok || !result.ok) throw new Error(result.error || 'Reaction preference was not saved.');
  } catch (error) {
    if (typeof displayWarning === 'function') displayWarning(error instanceof Error ? error.message : 'Reaction preference was not saved.');
  }
}
Object.assign(window, { ftSetReactionConsent: setReactionConsent });
